import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-233edd81"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Gefundene Objekte", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Diese Objekte hast du bereits gefunden, Gratulation!", -1))

import { useStore } from "vuex";
import { computed, inject } from "vue";
import ObjectPreview from "@/components/elements/ObjectPreview.vue";
import { CollectionObject } from "@/types";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const gamehandler: any = inject('gamehandler')

let collectedObjects = computed<Array<CollectionObject>>(() => {
  let objects: Array<CollectionObject> = []
  gamehandler.getCollectionArray().forEach((objectId: string) => {
    objects.push(store.getters['getObjectById'](objectId))
  })
  return objects
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("article", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collectedObjects), (object) => {
        return (_openBlock(), _createBlock(ObjectPreview, {
          key: object.uuid,
          object: object
        }, null, 8, ["object"]))
      }), 128))
    ])
  ], 64))
}
}

})